import React, { useState, useCallback } from 'react';
import { SketchPicker, RGBColor, ColorResult } from 'react-color';

import {
  Container,
  ColorContainer,
  ColorExample,
  Popover,
  Cover,
} from './styles';

interface PickerProprs {
  color: RGBColor;
  handleChange(color: ColorResult): void;
  isFightLoading: boolean;
}

const ColorPicker: React.FC<PickerProprs> = ({
  color,
  handleChange,
  isFightLoading,
}) => {
  const [showColorPicker, setShowColorPicker] = useState(false);

  const handleClick = useCallback(() => {
    setShowColorPicker(!showColorPicker);
  }, [showColorPicker, setShowColorPicker]);

  const handleClose = useCallback(() => {
    setShowColorPicker(false);
  }, [setShowColorPicker]);

  return (
    <Container loading={isFightLoading.toString()}>
      <ColorContainer onClick={handleClick}>
        <ColorExample r={color.r} g={color.g} b={color.b} />
      </ColorContainer>

      {showColorPicker ? (
        <Popover>
          <Cover onClick={handleClose} />
          <SketchPicker color={color} onChange={handleChange} />
        </Popover>
      ) : null}
    </Container>
  );
};

export default ColorPicker;
